import React from 'react'
import Profile from '../components/account/Profile'
import LOG from '../logging/Logger'

export default () => {
  LOG.debug('Render: ProfilePage')
  return <Profile />
}
